/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {makeStyles} from '@material-ui/core';
import {dlsColor} from '../../theme/theme';

const useClockDialStyles = makeStyles(() => ({
  root : {
    alignItems     : 'center',
    display        : 'flex',
    flexBasis      : '100%',
    justifyContent : 'center',
    marginTop      : 8,
    width          : '100%'
  },
  container : {
    backgroundColor : dlsColor('white'),
    padding         : '12px',
    width           : 280
  },
  face : {
    backgroundColor : dlsColor('grey8'),
    borderRadius    : 500,
    height          : 256,
    position        : 'relative',
    width           : 256
  },
  pin : {
    backgroundColor : dlsColor('darkTeal'),
    border          : `1px solid ${dlsColor('darkTeal')}`,
    borderRadius    : '50%',
    boxSizing       : 'border-box',
    height          : 8,
    left            : '50%',
    position        : 'absolute',
    top             : '50%',
    transform       : 'translate(-50%, -50%)',
    width           : 8
  },
  pointer : {
    cursor          : 'grab',
    height          : 104,
    left            : '50%',
    position        : 'absolute',
    top             : 24,
    transformOrigin : 'center 104px',
    width           : 2,
    pointerEvents   : 'none',
    zIndex          : 3,
    '&:active'      : {
      cursor : 'grabbing'
    }
  },
  pointerLine : {
    backgroundColor : dlsColor('darkTeal'),
    height          : '100%',
    left            : '50%',
    position        : 'absolute',
    pointerEvents   : 'none',
    transform       : 'translateX(-50%)',
    width           : 2
  },
  pointerThumb : {
    backgroundColor : dlsColor('darkTeal'),
    borderRadius    : '50%',
    height          : 40,
    left            : '50%',
    position        : 'absolute',
    pointerEvents   : 'none',
    top             : -20,
    transform       : 'translateX(-50%)',
    width           : 40
  },
  option : {
    alignItems         : 'center',
    backgroundColor    : 'transparent',
    border             : 0,
    borderRadius       : '50%',
    color              : dlsColor('grey1'),
    cursor             : 'pointer',
    display            : 'flex',
    fontFamily         : 'Inter',
    fontSize           : 16,
    fontWeight         : 400,
    height             : 48,
    justifyContent     : 'center',
    lineHeight         : '22px',
    padding            : 0,
    position           : 'absolute',
    textAlign          : 'center',
    width              : 48,
    zIndex             : 4,
    '&:hover, &:focus' : {
      backgroundColor : dlsColor('paleBlue'),
      outline         : 0
    }
  },
  activeOption : {
    backgroundColor    : dlsColor('darkTeal'),
    color              : dlsColor('white'),
    zIndex             : 6,
    '&:hover, &:focus' : {
      backgroundColor : dlsColor('darkTeal')
    }
  },
  dragHandle : {
    alignItems      : 'center',
    backgroundColor : dlsColor('darkTeal'),
    border          : 0,
    borderRadius    : '50%',
    color           : dlsColor('white'),
    cursor          : 'grab',
    display         : 'flex',
    fontFamily      : 'Inter',
    fontSize        : 16,
    fontWeight      : 400,
    height          : 48,
    justifyContent  : 'center',
    lineHeight      : '22px',
    padding         : 0,
    position        : 'absolute',
    textAlign       : 'center',
    width           : 48,
    zIndex          : 7,
    '&:active'      : {
      cursor : 'grabbing'
    }
  }
}));

export default useClockDialStyles;
